var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-0.0008232288528233767 -0.0005438327789306641 166.7100067138672 97.01139068603516",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u8D44\u6E90 19") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.65 75.14c-.47 9.73-6.41 17.94-15.44 20.76s-19-.13-24-8.33Q48.47 59.55 32.54 31C26.93 20.92 31 8.48 40.88 2.94 51.15-2.84 63.6.06 69.64 10.24 80.49 28.53 91.06 47 101.53 65.49c1.63 2.89 2.11 6.42 3.12 9.65zM115.18 0a20.32 20.32 0 0 1 17.13 10.4c10.63 18.21 21.26 36.43 31.62 54.8a21.12 21.12 0 0 1-7.69 28.71c-10 5.93-22.81 3.21-28.87-6.92-11-18.38-21.83-36.9-32.13-55.69C87.48 17.14 98 .1 115.18 0z",
    fill: "#1d2088"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 75.33C-.06 63 9.13 53.62 21.25 53.68a21.34 21.34 0 0 1 .06 42.68A20.85 20.85 0 0 1 0 75.33z",
    fill: "#7ecef4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9e277ec67eb8ed142bc8f73149e270a5.svg";
export { ForwardRef as ReactComponent };